import {
  ContainerExportFormPage,
  ContainerImportPage,
  createOtsRouter,
  DispatchRequestProfilePageRoute,
  DriverActivityPage, DVIRDashboardPage,
  DVIRFormPageRoute,
  DVIRProfilePageRoute,
  DVIRSearchPage,
  ErrorPage,
  IndexComponent,
  MeterImportPage,
  ShiftLocationHistoryMapPageRoute,
  ShiftProfilePageRoute, SiteSiteAssocImportPage,
  TicketComparePageRoute,
  TicketFormPageRoute,
  TicketLocationHistoryMapPageRoute,
  TicketProfilePageRoute,
  TransportFormPageRoute
} from "@ots-frontend/ots-ui";
import {AppAccessManagementPage, HelpSupportPage, UserProfilePage} from "@ots-frontend/ots-ui-tw";
import {ShiftFormPageRoute} from "../pages/ShiftFormPage/ShiftFormPageRoute";
import {DispatchProfilePageRoute} from "../pages/DispatchProfilePage/DispatchProfilePageRoute";
import {createBrowserRouter, createRoutesFromElements, Link, Navigate, Route, useNavigate} from "react-router-dom";
import {LoginPage} from "../pages/LoginPage/LoginPage";
import {AppOutlet} from "../app";
import {MapPage} from "../pages/MapPage/MapPage";
import {ContainerStatusPage} from "../pages/ContainerStatusPage/ContainerStatusPage";
import {DispatchPage} from "../pages/DispatchPage/DispatchPage";
import {DispatchFormPageRoute} from "../pages/DispatchFormPage/DispatchFormPage";
import {DispatchRequestPage} from "../pages/DispatchRequestPage/DispatchRequestPage";
import {DispatchRequestPendingPage} from "../pages/DispatchRequestPendingPage/DispatchRequestPendingPage";
import {DispatchRequestAcceptFormPageRoute} from "../pages/DispatchRequestAcceptPage/DispatchRequestAcceptPage";
import {TicketPage} from "../pages/TicketPage/TicketPage";
import {ShiftPage} from "../pages/ShiftPage/ShiftPage";
import {Anchor} from "@mantine/core";
import {DriverActivityWorkspacePage} from "../pages/DriverActivityWorkspacePage/DriverActivityWorkspacePage";
import {DriverActivityDayPage} from "../pages/DriverActivityDayPage/DriverActivityDayPage";
import {ToolsPage} from "../pages/ToolsPage/ToolsPage";
import {
  DispatchRequestAddDispatchPageRoute
} from "../pages/DispatchRequestAddDispatchPage/DispatchRequestAddDispatchPage";
import {DVIRReviewFormPageRoute} from "../pages/DVIRReviewFormPage/DVIRReviewFormPage";
import {DispatchGoAuthProvider} from "../auth/DispatchGoAuthProvider/DispatchGoAuthProvider";

const UserProfilePageRoute = () => {
  const navigate = useNavigate();

  return <UserProfilePage onManageNotifications={() => navigate("/notifications")}/>;
};

export const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<DispatchGoAuthProvider/>}>
        <Route path="/login" element={<LoginPage/>}/>
        <Route element={<AppOutlet/>}>
          <Route index element={<IndexComponent/>}/>

          <Route path="driver-activity/*" element={<IndexComponent/>}>
            {/* The workspace is the page; the legacy day grid stays reachable while people move over. */}
            <Route index element={<DriverActivityWorkspacePage/>}/>
            {/* Links shared while the workspace was a staff preview. */}
            <Route path="workspace" element={<DriverActivityWorkspacePage/>}/>
            <Route path="legacy" element={<DriverActivityDayPage/>}/>
            <Route path="search" element={<DriverActivityPage/>}/>
          </Route>

          <Route path="dispatch/*" element={<IndexComponent/>}>
            <Route index element={<DispatchPage/>}/>
            <Route path="form" element={<DispatchFormPageRoute/>}/>
            <Route path="profile" element={<DispatchProfilePageRoute/>}/>
          </Route>

          <Route path="dvirs/*" element={<IndexComponent/>}>
            <Route index element={<DVIRDashboardPage/>}/>
            <Route path="search" element={<DVIRSearchPage/>}/>
            <Route path="form" element={<DVIRFormPageRoute/>}/>
            <Route path="mechanic-review" element={<DVIRReviewFormPageRoute/>}/>
            <Route path="profile" element={<DVIRProfilePageRoute/>}/>
          </Route>

          <Route path="transports/*" element={<IndexComponent/>}>
            <Route index element={<div/>}/>
            <Route path="form" element={<TransportFormPageRoute/>}/>
          </Route>

          <Route path="container-status/*" element={<IndexComponent/>}>
            <Route index element={<ContainerStatusPage/>}/>
          </Route>

          <Route path="requests/*" element={<IndexComponent/>}>
            <Route index element={<DispatchRequestPage/>}/>
            <Route path="pending" element={<DispatchRequestPendingPage/>}/>
            <Route path="profile" element={<DispatchRequestProfilePageRoute/>}/>
            <Route path="accept" element={<DispatchRequestAcceptFormPageRoute/>}/>
            <Route path="add-dispatch" element={<DispatchRequestAddDispatchPageRoute/>}/>
          </Route>

          <Route path="tickets/*" element={<IndexComponent/>}>
            <Route index element={<TicketPage/>}/>
            <Route path="form" element={<TicketFormPageRoute/>}/>
            <Route path="compare" element={<TicketComparePageRoute/>}/>
            <Route
              path="profile/*"
              element={<IndexComponent/>}
              handle={{
                crumb: () => (
                  <Anchor component={Link} to={`..`} key="ticket_profile">
                    Ticket
                  </Anchor>
                )
              }}>
              <Route index element={<TicketProfilePageRoute/>}/>
              <Route path="map" element={<TicketLocationHistoryMapPageRoute/>}/>
            </Route>
          </Route>

          <Route path="shifts/*" element={<IndexComponent/>}>
            <Route index element={<ShiftPage/>}/>
            <Route path="form" element={<ShiftFormPageRoute/>}/>
            <Route
              path="profile/*"
              element={<IndexComponent/>}
              handle={{
                crumb: () => (
                  <Anchor component={Link} to={`..`} key="shift_profile">
                    Shift
                  </Anchor>
                )
              }}>
              <Route index element={<ShiftProfilePageRoute/>}/>
              <Route path="map" element={<ShiftLocationHistoryMapPageRoute/>}/>
            </Route>
          </Route>

          <Route path="map/*" element={<IndexComponent/>}>
            <Route index element={<MapPage/>}/>
          </Route>

          {createOtsRouter({
            persons: {
              showStatus: true,
            }
          })}

          <Route path="directory" element={<ToolsPage/>}/>
          <Route path="app-access" element={<AppAccessManagementPage/>}/>

          <Route path="profile" element={<UserProfilePageRoute/>}/>
          <Route path="help" element={<HelpSupportPage/>}/>

          <Route path="export/*" element={<IndexComponent/>}>
            <Route path="containers" element={<ContainerExportFormPage/>}/>
          </Route>

          <Route path="import/*" element={<IndexComponent/>}>
            <Route path="containers" element={<ContainerImportPage/>}/>
            <Route path="meters" element={<MeterImportPage/>}/>
            <Route path="site-site-assocs" element={<SiteSiteAssocImportPage/>}/>
          </Route>

          <Route path="*" element={<ErrorPage/>}/>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={"/"} replace/>}/>
    </>
  ),
  {
    basename: import.meta.env.BASE_URL
  }
);
